// extracted by mini-css-extract-plugin
export default {"headerBar":"uJ-z","pointsSection":"vJ-z","goToDashboard":"wJ-z"};